import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const actions = {
    findById: {
        method: 'GET',
        url: `${BASE_PATH_API}/users/associationTenants/:id`
    },
    deleteAssociationTenant: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/users/associationTenants/:id`
    },
    saveTenant: {
        method: 'POST',
        url: `${BASE_PATH_API}/users/associationTenants`
    },
    getTenantOwnershipAccounts: {
        method: 'GET',
        url: `${BASE_PATH_API}/users/associationTenants/:id/ownershipAccounts`,
        isArray: true
    },
    updateAssociationTenant: {
        method: 'PUT',
        url: `${BASE_PATH_API}/users/associationTenants/:id`
    },
    moveOutAssociationTenants: {
        method: 'POST',
        url: `${BASE_PATH_API}/users/associationTenants/moveout`
    },
    undoMoveOutAssociationTenant: {
        method: 'PUT',
        url: `${BASE_PATH_API}/users/associationTenants/:associationTenantId/ownershipAccounts/:ownershipAccountId/undoMoveOut`
    },
    removeAssociationTenant: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/users/ownershipAccounts/:ownershipAccountId/associationTenants/:associationTenantId`
    }
};

export function AssociationTenantsApi() {
    return createActions(actions);
}
